export const HOVER_DEFAULTS = {
    isAnchorMoused: false,
    isScrolling: false,
}
